import React from 'react';
import ReactDOM from 'react-dom';
import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { EngineContext } from '@surveycake/react-logic-engine';
import { ExceptionService } from 'app/core/status';
import { PageService } from 'app/core/page';
import { SurveyConfig, SurveyConfigProvider } from 'app/core/survey-config';
import { Tracker, TrackerProvider } from 'app/core/tracker';
import App from './App';

export interface BootstrapAppInfos {
  element: HTMLElement | null;
}

export type BootstrapAppProviders = [
  SurveyCakeLogicEngine,
  SurveyConfig,
  Tracker
];

export interface BootstrapAppConfig {
  infos: BootstrapAppInfos;
  providers: BootstrapAppProviders;
}

export function bootstrapApp({ infos, providers }: BootstrapAppConfig) {
  const { element } = infos;
  const [engine, surveyConfig, tracker] = providers;

  ReactDOM.render(
    <ExceptionService>
      <PageService>
        <TrackerProvider tracker={tracker}>
          <EngineContext.Provider value={engine}>
            <SurveyConfigProvider surveyConfig={surveyConfig}>
              {initialed => initialed && <App />}
            </SurveyConfigProvider>
          </EngineContext.Provider>
        </TrackerProvider>
      </PageService>
    </ExceptionService>,
    element
  );
}
